import Swiper from 'swiper';
import { Scrollbar } from 'swiper/modules';
import 'swiper/swiper-bundle.css';

export default function (element, data) {
    const swiperOptions = {
        modules: [Scrollbar],
        slidesPerView: 'auto',
        spaceBetween: 10,
        // slidesOffsetBefore: 20,
        scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
        },
        breakpoints: {
            1240: {
                // slidesOffsetBefore: 125,
            },
            768: {
                // slidesOffsetBefore: 60,
            }
        }
    };

    element.swiper = new Swiper(element.querySelector(".member__what-swiper"), swiperOptions);
};